<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="d12e86"><b><i>For my husband</i></b></p>
<p class="h1" id="d12e90"><b>K</b><b>EN </b><b>T</b><b>ADA</b></p>
<p class="extc" id="d12e99"><i>who has journeyed alongside my wheelchair </i><i>these many years, giving love and support </i><i>every step of the way.</i></p>
<p class="ser"><img alt="0310262984_content_0005_005" id="d12e106" src="images/0310262984_content_0005_005.jpg"/></p><p class="txc" id="d12e107"><b><i>For</i></b></p>
<p class="h1" id="d12e111"><b>S</b><b>TEVE </b><b>E</b><b>STES</b></p>
<p class="extc" id="d12e120"><i>whose teaching from God’s Word </i><br/><i>has enriched my life these many years.</i><br/><i>If anyone gleans something precious from this book, </i><br/><i>I probably learned it first from him.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Tada_9780310297864_epub_c2b_r1.vue?2d26fd35